import { Badge } from '@@/Badge';

import { AlertRuleRow } from './types';
import { severityConfig, severityToBadgeType } from './utils';

interface Props {
  severity: AlertRuleRow['severity'];
}

export function AlertSeverityBadge({ severity }: Props) {
  return (
    <Badge type={severityToBadgeType(severity)} className="text-xs">
      {severityConfig[severity].label}
    </Badge>
  );
}
